import { gql } from "@apollo/client";

export const SEARCH_GROUP = gql`
  query SearchGroup($categories: [String], $search: String!, $limit: Int) {
    searchGroup(categories: $categories, search: $search, limit: $limit) {
      id
      status
      name
      title
      category
      certified
      educations {
        id
        status
        title
        diplomaType
        education 
      }
      logo {
        id
        title
        filename
        filesize
        filetype
        url
      }
      logo2 {
        id
        title
        filename
        filesize
        filetype
        url
      }
      logo3 {
        id
        title
        filename
        filesize
        filetype
        url
      }
      groups {
        id
        status
        name
        title
        category
        groups {
          id
          status
          name
          title
          category
        }
      }
      parentGroups {
        id
        status
        name
        title
        logo {
          id
          title
          filename
          filesize
          filetype
          url
        }
        logo2 {
          id
          title
          filename
          filesize
          filetype
          url
        }
        logo3 {
          id
          title
          filename
          filesize
          filetype
          url
        }
        parentGroups {
          id
          name
          title
          logo {
            id
            title
            filename
            filesize
            filetype
            url
          }
          logo2 {
            id
            title
            filename
            filesize
            filetype
            url
          }
          logo3 {
            id
            title
            filename
            filesize
            filetype
            url
          }
        }
      }
    }
  }
`;

